module.exports = __webpack_public_path__ + "img/workout-notebook_B095Q9W5KQ.b09f5fcd.jpg";